import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table7IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class Table7 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      name: '尼古丁成癮度診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table7',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5'
    }
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.handleChangeAns8 = this.handleChangeAns8.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.goToTable7 = this.goToTable7.bind(this)
    this.goToTable8 = this.goToTable8.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable7() {
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    const table7 = ReactDOM.findDOMNode(this.refs.table7)
    table6.classList.remove('isShow')
    table7.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable8() {
    const table7 = ReactDOM.findDOMNode(this.refs.table7)
    const table8 = ReactDOM.findDOMNode(this.refs.table8)
    table7.classList.remove('isShow')
    table8.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1))
    if(total < 50) {
      rootRef.update({
        Reviews: '您屬於低成癮者，想戒菸的話，只要憑自我意志力即可。(建議您此時就下定決心立即戒菸)',
        ans: total,
        name: '尼古丁成癮度診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table7',
        localUrl: '/Table7',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5'
      })
    } else if (total < 75) {
      rootRef.update({
        Reviews: '您屬於中成癮者，想戒菸的話，建議您聽從醫師／藥師指示，以正確輕鬆的科學方法幫助您戒菸。',
        ans: total,
        name: '尼古丁成癮度診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table7',
        localUrl: '/Table7',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5'
      })
    } else {
      rootRef.update({
        Reviews: '您屬於高成癮者，您的生命健康已受侵害，為了自己及關心您的人，您務必要戒菸',
        ans: total,
        name: '尼古丁成癮度診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table7',
        localUrl: '/Table7',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable7.jpg?alt=media&token=b175f1bf-e458-4fa2-88c5-c2606ebf4cb5'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is12-5')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is12-5')
    sliderBar.classList.add('is25')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is25')
    sliderBar.classList.add('is37-5')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is37-5')
    sliderBar.classList.add('is50')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is50')
    sliderBar.classList.add('is62-5')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is62-5')
    sliderBar.classList.add('is75')
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is75')
    sliderBar.classList.add('is87-5')
    const toNext7 = ReactDOM.findDOMNode(this.refs.toNext7)
    scrollToComponent(toNext7, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is87-5')
    sliderBar.classList.add('is100')
    const toNext8 = ReactDOM.findDOMNode(this.refs.toNext8)
    scrollToComponent(toNext8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = this.state.ans1
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = this.state.ans2
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = this.state.ans3
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = this.state.ans4
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>快完成了</div>
     : null
    const nextBtn5 = this.state.ans5
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>再接再厲</div>
     : null
    const nextBtn6 = this.state.ans6
     ? <div className="nextTablebtnDefault" onClick={this.goToTable7}>下一題</div>
     : null
    const nextBtn7 = this.state.ans7
     ? <div className="nextTablebtnDefault" onClick={this.goToTable8}>只剩一題了</div>
     : null
    const nextBtn8 = this.state.ans8
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null
    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table7">
           <h1>飯後必來一根菸?</h1>
           <h2>戒除菸癮 遠離肺癌</h2>
           <p className="moileNone">
           有些人抽菸是為了發洩、放鬆、減肥、耍帥...<br />
           貌似快樂似神仙，卻不知肺臟已經烏黑脹氣了<br />
           遠離菸害，拒絕誘惑刻不容緩
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table7'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table7'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>尼古丁成癮度診斷</h2>
            <sub>平時習慣或有抽菸的人, 趕快看看自己屬於哪一個成癮度吧</sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
             <div className="table1 isShow" ref="table1">
              <article ref="toNext1">
               <h1>Q1:當您起床多久抽第一根菸?</h1>
               <input type="radio" value='12'
                id="ans1"
                checked={this.state.ans1 === '12'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">30 分鐘內</label>
               <input type="radio" value='2'
                id="ans2"
                checked={this.state.ans1 === '2'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">30 分鐘以上</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toNext2">
               <h1>Q2:您在禁菸場所是否難以忍受?</h1>
               <input type="radio" value='12'
                id="ans3"
                checked={this.state.ans2 === '12'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans3">是</label>
               <input type="radio" value='2'
                id="ans4"
                checked={this.state.ans2 === '2'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans4">否</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toNext3">
               <h1>Q3:每日的哪一根菸您通常不願錯過?</h1>
               <input type="radio" value='12'
                id="ans5"
                checked={this.state.ans3 === '12'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans5">早晨的第一支</label>
               <input type="radio" value='2'
                id="ans6"
                checked={this.state.ans3 === '2'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans6">無</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toNext4">
               <h1>Q4:您一天平均抽幾根菸?</h1>
               <input type="radio" value='6'
                id="ans7"
                checked={this.state.ans4 === '6'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans7">15 支以下</label>
               <input type="radio" value='12'
                id="ans8"
                checked={this.state.ans4 === '12'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans8">15 支~25 支</label>
               <input type="radio" value='18'
                id="ans9"
                checked={this.state.ans4 === '18'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans9">26 支以上</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toNext5">
               <h1>Q5:早晨抽菸量是否多於其他時間?</h1>
               <input type="radio" value='12'
                id="ans10"
                checked={this.state.ans5 === '12'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans10">是</label>
               <input type="radio" value='2'
                id="ans11"
                checked={this.state.ans5 === '2'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans11">否</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table6" ref="table6">
              <article ref="toNext6">
               <h1>Q6:生病臥床您仍抽菸?</h1>
               <input type="radio" value='12'
                id="ans12"
                checked={this.state.ans6 === '12'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans12">是</label>
               <input type="radio" value='2'
                id="ans13"
                checked={this.state.ans6 === '2'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans13">否</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
              <div className="table7" ref="table7">
              <article ref="toNext7">
               <h1>Q7:您抽的香菸品牌含尼古丁量?(請對照尼古丁含量一覽表)</h1>
               <input type="radio" value='2'
                id="ans14"
                checked={this.state.ans7 === '2'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans14">0.9 mg 以內</label>
               <input type="radio" value='6'
                id="ans15"
                checked={this.state.ans7 === '6'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans15">1~1.2 mg</label>
               <input type="radio" value='12'
                id="ans16"
                checked={this.state.ans7 === '12'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans16">1.3 mg 以上</label>
              </article>
               <div>{ nextBtn7 }</div>
              </div>
              <div className="table8" ref="table8">
              <article ref="toNext8">
               <h1>Q8:您將菸吸入肺部?</h1>
               <input type="radio" value='2'
                id="ans17"
                checked={this.state.ans8 === '2'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans17">從沒有</label>
               <input type="radio" value='6'
                id="ans18"
                checked={this.state.ans8 === '6'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans18">有時吸入</label>
               <input type="radio" value='12'
                id="ans19"
                checked={this.state.ans8 === '12'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans19">經常吸入</label>
              </article>
               <div>{ nextBtn8 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table7;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#d0ad42'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table7.js